import React, { Component } from "react";
import {
  Col,
  Container,
  Form,
  FormControl,
  Row,
  Table,
  Modal,
  Button,
  Image,
} from "react-bootstrap";
import "./PromoPricing.scss";
import DeleteIcon from "../../../assets/images/DeleteIcon.svg";
import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import Footer from "../commonAdmin/Footer";
import Loader from "../../common/Loader";
import delivaApiService from "../../../common/services/apiService";
import {
  getLocalStorage,
  showSuccessToast,
  showErrorToast,
} from "../../../common/helpers/Utils";
import moment from "moment";
import { ReactComponent as Edit } from "./../../../assets/images/icons/edit.svg";
import { ReactComponent as Copy } from "./../../../assets/images/icons/copy.svg";
import { ReactComponent as SlidersHorizontal } from "../../../assets/images/SlidersHorizontal.svg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import promoPricingGuidePDF from "../../../assets/pdf/DelivaHere Promo Pricing Guide.pdf";

class PromoPricingList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dataList: [],
      pageno: 1,
      records: 10,
      inputRecords: 10,
      totalPage: 0,
      pageArray: [],
      searchText: "",
      filterStatus: "",
      filterCurrency: "",
      filterRequestType: "",
      sortBy: "",
      showFilterPanel: false,
      showDeleteModal: false,
      selectedItem: null,
    };
  }

  componentDidMount() {
    if (getLocalStorage("adminInfo")) {
      this.fetchList();
    } else {
      this.props.history.push("/login");
    }
  }

  fetchList(page, records) {
    const {
      pageno: p,
      records: r,
      filterStatus,
      filterCurrency,
      filterRequestType,
      searchText,
      sortBy,
    } = this.state;
    const payload = {
      page: page != null ? page : p,
      size: records != null ? records : r,
      status: filterStatus || "",
      currency: filterCurrency || "",
      requestType: filterRequestType || "",
      searchKey: searchText || "",
      sortBy: sortBy || "",
    };
    this.setState({
      loading: true,
      pageno: payload.page,
      records: payload.size,
    });
    delivaApiService("getPromoPricingList", payload)
      .then((res) => {
        const rd = res && res.data && res.data.resourceData;
        if (rd) {
          const items = rd.data || rd || [];
          const total = rd.totalElements || rd.totalRecords || 0;
          const totalPages =
            rd.totalPages ||
            (payload.size > 0 ? Math.ceil(total / payload.size) : 1) ||
            1;
          this.setState({
            dataList: Array.isArray(items) ? items : [],
            totalPage: totalPages,
            pageArray: this.buildPageArray(totalPages, payload.page),
            loading: false,
          });
        } else {
          this.setState({ loading: false, dataList: [] });
        }
      })
      .catch(() => this.setState({ loading: false }));
  }

  buildPageArray(totalPages, currentPage) {
    if (!totalPages || totalPages < 1) return [];
    let start, end;
    if (totalPages <= 5) {
      start = 1;
      end = totalPages;
    } else if (currentPage <= 3) {
      start = 1;
      end = 5;
    } else if (currentPage + 1 >= totalPages) {
      start = totalPages - 4;
      end = totalPages;
    } else {
      start = currentPage - 2;
      end = currentPage + 2;
    }
    const arr = [];
    for (let i = start; i <= end; i++) arr.push(i);
    return arr;
  }

  onChangePage(page) {
    if (page < 1 || page > this.state.totalPage || page === this.state.pageno)
      return;
    this.fetchList(page);
  }

  onEnterPerPage = (e) => {
    if (e.key === "Enter") {
      const val = parseInt(this.state.inputRecords, 10);
      if (val > 0) this.fetchList(1, val);
    }
  };

  handleSearchChange = (e) => {
    const val = e.target.value;
    this.setState({ searchText: val }, () => {
      if (val === "") this.fetchList(1);
    });
  };

  handleSearch = () => {
    this.fetchList(1);
  };

  handleSearchKeyDown = (e) => {
    if (e.key === "Enter") this.handleSearch();
  };

  handleFilterChange = (key, value) => {
    this.setState({ [key]: value, pageno: 1 }, () => this.fetchList(1));
  };

  handleToggle = (item, checked) => {
    const endpoint = checked
      ? "activatePromoPricing"
      : "deactivatePromoPricing";
    delivaApiService(endpoint, { id: item.id }).then((res) => {
      if (res && res.data && res.data.status === 200) {
        this.fetchList();
      } else {
        // showErrorToast("Failed to update status.");
      }
    });
    // .catch(() => // showErrorToast("Failed to update status.")
    // );
  };

  confirmDelete = () => {
    const { selectedItem } = this.state;
    if (!selectedItem) return;
    delivaApiService("deletePromoPricing", { id: selectedItem.id })
      .then((res) => {
        if (res && res.data && res.data.status === 200) {
          // showSuccessToast("Deleted successfully.");
          this.setState({ showDeleteModal: false, selectedItem: null }, () =>
            this.fetchList(),
          );
        } else {
          // showErrorToast("Failed to delete.");
          this.setState({ showDeleteModal: false, selectedItem: null });
        }
      })
      .catch(() => {
        // showErrorToast("Failed to delete.");
        this.setState({ showDeleteModal: false, selectedItem: null });
      });
  };

  getStatusText(isActive, isDraft) {
    if (isDraft)
      return <span className="color-draft font-weight-bold">Draft</span>;
    if (isActive)
      return <span className="color-green font-weight-bold">Active</span>;
    return <span className="color-orange font-weight-bold">Inactive</span>;
  }

  formatDuration(item) {
    const start = item.start_date
      ? moment(item.start_date).format("DD MMM YYYY")
      : "--";
    const end = item.end_date
      ? moment(item.end_date).format("DD MMM YYYY")
      : "Ongoing";
    return `${start} - ${end}`;
  }

  formatRequestType(val) {
    if (!val) return "--";
    return val
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  render() {
    const {
      loading,
      dataList,
      pageno,
      totalPage,
      pageArray,
      inputRecords,
      searchText,
      filterStatus,
      filterRequestType,
      filterCurrency,
      showFilterPanel,
      showDeleteModal,
    } = this.state;
    return (
      <div className="page__wrapper h-100">
        <Header {...this.props} />
        <div className="mainContainer CustomerTable">
          <Row noGutters className="h-100">
            <Sidebar {...this.props} />
            <Col md={9} lg={10} className="boxTyp3 d-flex flex-column">
              <Container fluid className="flex-fill">
                <div className="content-wrapper">
                  <Loader showLoader={loading} />

                  {/* Page Header */}
                  <div className="page-header mb-3 d-flex flex-row align-items-center justify-content-between">
                    <h3 className="font-weight-normal mb-0 line-ht fs-24 color-33 text-nowrap">
                      Promotional Pricing
                    </h3>
                    <div className="page-search d-flex  justify-content-end gap-3 w-100">
                      <div className="d-flex gap-3">
                        {/* Search */}
                        <div className="mxw-90">
                          <FormControl
                            type="text"
                            placeholder="Search by Promotion Name"
                            className="searchTxt mb-3 mb-lg-0"
                            value={searchText}
                            onChange={this.handleSearchChange}
                            onKeyDown={this.handleSearchKeyDown}
                          />
                          <span
                            onClick={this.handleSearch}
                            className="icon-search pointer"
                          ></span>
                        </div>

                        {/* Filter toggle button */}
                        <button
                          className="pp-filter-btn"
                          title="Filter"
                          onClick={() =>
                            this.setState({ showFilterPanel: !showFilterPanel })
                          }
                        >
                          <SlidersHorizontal />
                        </button>

                        {/* Create New */}
                        <button
                          className="button rounded-pill btnPrimary text-nowrap px-4"
                          onClick={() =>
                            this.props.history.push("/addPromoPricing")
                          }
                        >
                          Create New
                        </button>

                        {/* View Guideline */}
                        <button
                          className="button rounded-pill btnDefault btnOutline text-nowrap px-4"
                          onClick={() =>
                            window.open(promoPricingGuidePDF, "_blank")
                          }
                        >
                          View Guideline
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Filter Panel */}
                  {showFilterPanel && (
                    <div className="pp-filter-panel">
                      <p className="pp-filter-title">Filter</p>
                      <div className="row g-3 mb-4">
                        <div className="col-lg-3 col-md-6 col-12 mb-4 mb-lg-0 pr-1">
                          <Form.Control
                            as="select"
                            custom
                            className="login-input select-rounded"
                            value={filterStatus}
                            onChange={(e) =>
                              this.setState({ filterStatus: e.target.value })
                            }
                          >
                            <option value="">Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </Form.Control>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12 mb-4 mb-lg-0 pr-1">
                          <Form.Control
                            as="select"
                            custom
                            className="login-input select-rounded"
                            value={filterCurrency}
                            onChange={(e) =>
                              this.setState({ filterCurrency: e.target.value })
                            }
                          >
                            <option value="">Currency</option>
                            <option value="NGN">NGN</option>
                            <option value="USD">USD</option>
                          </Form.Control>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12 mb-4 mb-md-0 pr-1">
                          <Form.Control
                            as="select"
                            custom
                            className="login-input select-rounded"
                            value={filterRequestType}
                            onChange={(e) =>
                              this.setState({
                                filterRequestType: e.target.value,
                              })
                            }
                          >
                            <option value="">Delivery Type</option>
                            <option value="LOCAL">Local</option>
                            <option value="INTERSTATE">Interstate</option>
                            <option value="INTERNATIONAL">International</option>
                          </Form.Control>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12">
                          <Form.Control
                            as="select"
                            custom
                            className="login-input select-rounded"
                            value={this.state.sortBy || ""}
                            onChange={(e) =>
                              this.setState({ sortBy: e.target.value })
                            }
                          >
                            <option value="">Sort By</option>
                            <option value="priority">Priority</option>
                            <option value="start_date">Start Date</option>
                            <option value="end_date">End Date</option>
                          </Form.Control>
                        </div>
                      </div>
                      <div className="pp-filter-actions">
                        <button
                          className="btnDefault btnOutline pp-filter-btn-action"
                          onClick={() =>
                            this.setState({ showFilterPanel: false })
                          }
                        >
                          Close
                        </button>
                        <button
                          className="btnDefault btnOutline pp-filter-btn-action"
                          onClick={() =>
                            this.setState(
                              {
                                filterStatus: "",
                                filterCurrency: "",
                                filterRequestType: "",
                                sortBy: "",
                              },
                              () => this.fetchList(1),
                            )
                          }
                        >
                          Clear
                        </button>
                        <button
                          className="btnDefault btnPrimary pp-filter-btn-action"
                          onClick={() => {
                            this.setState({ showFilterPanel: false });
                            this.fetchList(1);
                          }}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Table */}
                  <div className="row">
                    <div className="col-sm-12 order-boxlist">
                      <Table
                        responsive={dataList && dataList.length > 0}
                        className="w-100 promo-table"
                      >
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Delivery type</th>
                            <th>Duration</th>
                            <th>Currency</th>
                            <th>Usage</th>
                            <th>Priority</th>
                            <th>Status</th>
                            <th>Active / Inactive</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody className="ttl-order-table">
                          {dataList && dataList.length > 0 ? (
                            dataList.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{item.name || "--"}</td>
                                <td>
                                  {this.formatRequestType(item.request_types)}
                                </td>
                                <td>{this.formatDuration(item)}</td>
                                <td>{item.currency || "--"}</td>
                                <td>
                                  {item?.usage?.total_usage_count > 0 ? (
                                    <Link
                                      className="link pointer"
                                      to={{
                                        pathname: `/promoPricingDetails/${item.id}`,
                                        state: { collapseSections: true },
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        this.props.history.push({
                                          pathname: `/promoPricingDetails/${item.id}`,
                                          state: { collapseSections: true },
                                        });
                                      }}
                                    >
                                      {item.usage.total_usage_count}
                                    </Link>
                                  ) : (
                                    (item?.usage?.total_usage_count ?? 0)
                                  )}
                                </td>
                                <td>{item.priority ?? "--"}</td>
                                <td>
                                  {this.getStatusText(
                                    item.is_active,
                                    item.is_draft,
                                  )}
                                </td>
                                <td>
                                  <Form className="text-center">
                                    <Form.Check
                                      type="switch"
                                      id={`promo-pricing-switch-${index}`}
                                      label=""
                                      className="custom-switch-green"
                                      checked={!!item.is_active}
                                      disabled={item.is_draft}
                                      onChange={(e) =>
                                        this.handleToggle(
                                          item,
                                          e.target.checked,
                                        )
                                      }
                                    />
                                  </Form>
                                </td>
                                <td>
                                  <div className="action-buttons d-flex w-100">
                                    <span
                                      className="links pointer"
                                      title="View Details"
                                      onClick={() =>
                                        this.props.history.push(
                                          `/promoPricingDetails/${item.id}`,
                                        )
                                      }
                                    >
                                      <i className="icon-eye"></i>
                                    </span>
                                    <span
                                      className="links pointer"
                                      title="Copy Promo"
                                      onClick={() =>
                                        this.props.history.push({
                                          pathname: "/copyPromoPricing",
                                          state: {
                                            id: item.id,
                                            isCopied: true,
                                          },
                                        })
                                      }
                                    >
                                      <Copy />
                                    </span>
                                    <span
                                      className={`links ${item?.is_active ? "disabled" : ""} pointer`}
                                      title="Edit"
                                      onClick={() =>
                                        this.props.history.push({
                                          pathname: "/editPromoPricing",
                                          state: { id: item.id },
                                        })
                                      }
                                    >
                                      <Edit />
                                    </span>
                                    <span
                                      className={`links ${item?.is_active ? "disabled" : ""} pointer`}
                                      title="Delete"
                                      onClick={() =>
                                        this.setState({
                                          showDeleteModal: true,
                                          selectedItem: item,
                                        })
                                      }
                                    >
                                      <i className="icon-bin"></i>
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9" className="text-center">
                                No Records Available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>

                      {/* Pagination */}
                      {dataList && dataList.length > 0 && (
                        <nav
                          aria-label="Page navigation"
                          className="position-relative"
                        >
                          <ul className="pagination pg-blue deliva-pagination justify-content-end">
                            <li className="page-item">
                              <button
                                className="page-link rotate-180 control-btn"
                                aria-label="Previous"
                                onClick={() => this.onChangePage(pageno - 1)}
                                disabled={pageno === 1 || totalPage === 0}
                              >
                                <span className="icon-next"></span>
                                <span className="sr-only">Previous</span>
                              </button>
                            </li>
                            {totalPage > 0 &&
                              pageArray.map((page, idx) => (
                                <li key={idx} className="page-item">
                                  <a
                                    className={`page-link ${
                                      pageno === page ? "active" : ""
                                    }`}
                                    onClick={() => this.onChangePage(page)}
                                  >
                                    {page}
                                  </a>
                                </li>
                              ))}
                            <li className="page-item">
                              <button
                                className="page-link control-btn"
                                aria-label="Next"
                                onClick={() => this.onChangePage(pageno + 1)}
                                disabled={
                                  pageno === totalPage || totalPage === 0
                                }
                              >
                                <span className="icon-next"></span>
                                <span className="sr-only">Next</span>
                              </button>
                            </li>
                            <li className="page-value">
                              Enter Per Page{" "}
                              <input
                                type="text"
                                placeholder="Records"
                                name="records"
                                value={inputRecords}
                                onChange={(e) =>
                                  this.setState({
                                    inputRecords: e.target.value,
                                  })
                                }
                                onKeyDown={this.onEnterPerPage}
                              />
                            </li>
                          </ul>
                        </nav>
                      )}
                    </div>
                  </div>
                </div>
              </Container>
              <Footer />
            </Col>
          </Row>
        </div>

        {/* Delete Confirmation Modal */}
        <Modal
          show={showDeleteModal}
          onHide={() =>
            this.setState({ showDeleteModal: false, selectedItem: null })
          }
          centered
          className="deliva-popup"
        >
          <Modal.Body>
            <div className="modal-content-wrap">
              <div className="text-center">
                <Image src={DeleteIcon} className="img-fluid reject-img" />
                <h4 className="mt-4 font-weight-normal mb-3 fs-24">
                  Delete Promotion
                </h4>
                <p className="color-grey">
                  Are you sure you want to
                  <br />
                  delete this promotion?
                </p>
                <p className="pp-delete-note">This action cannot be undone.</p>
              </div>

              <div className="text-center mt-5">
                <button
                  type="button"
                  className="cancel-btn py-2 mr-4 min-w-80"
                  onClick={() =>
                    this.setState({
                      showDeleteModal: false,
                      selectedItem: null,
                    })
                  }
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="df-button danger  min-w-80"
                  onClick={this.confirmDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default PromoPricingList;
